import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import CampaignsMainViewDataLoader from '../../../../core/components/campaigns/campaignsmain';
import CampaignsMainView from '../CampaignsMainView';
import CampaignDetailsDataLoader from '../../../.././core/components/campaigns/campaigndetails';
import CampaignDetailsChartsDataLoader from '../../../../core/components/campaigns/campaigndetails/CampaignDetailsChartsDataLoader';

import CampaignsDetailsView from '../campaigndetails/CampaignsDetailsView';
// TEMP: Usage page hidden - restore these imports with the route below
// import UsageLoader from '../../../../core/components/usage';
// import UsageView from '../usage/UsageView';
import AmplifyView from '../campaigndetails/amplify/AmplifyView';
import CampaignLauncherLoader from '../../../../core/components/campaignLauncher';
import CampaignOrderAuditView from '../../CampaignOrderAudit/CampaignOrderAuditView';
import CampaignOrderAuditLoader from '../../../../core/components/campaigns/campaignorderaudit/CampaignOrderAuditLoader';
// import GeotargetManagerLoader from "../../../../core/components/campaigns/geotargetmanager/GeotargetManagerLoader";
import CampaignRequestorEdit from '../../CampaignRequestor/CampaignRequestorEdit';
import CampaignRequestorReview from '../../CampaignRequestor/CampaignRequestorReview';
import { CampaignRequestorProvider } from '../../../../core/components/campaignRequestor/CampaignRequestorProvider';
import { LocationProvider } from '../../../../core/components/locations/LocationProvider';
import { TagProvider } from '../../../../core/components/tags/TagProvider';
import { TargetingProvider } from '../../../../core/components/targeting/TargetingProvider';
import { AudienceProvider } from '../../../../core/components/audiences/AudienceProvider';
import { CreativeProvider } from '../../../../core/components/creatives/main/CreativeProvider';
import { CampaignOrderQueue } from '../../CampaignOrderQueue/components/CampaignOrderQueue';
import { CampaignOrderQueueProvider } from '../../../../core/components/campaigns/campaignordersqueue/CampaingOrderQueueProvider';
import { CampaignOrderQueueReview } from '../../CampaignOrderQueue/components/CampaignOrderQueueReview';
import { DealIdProvider } from '../../../../core/components/dealIds/DealIdProvider';
// import CampaignOrderQueueView from "../../CampaignOrderQueue/CampaignOrderQueueView";
// import CampaignOrdersQueueLoader from "../../../../core/components/campaigns/campaignordersqueue/CampaignOrdersQueueLoader";
import { OrgProvider } from '../../../../core/components/orgs/OrgProvider';

const CampaignsRoutes = (props) => {
  const { path } = props.match;

  return (
    <div>
      <Switch>
        <Route
          exact
          path={`${path}/main/:pageNumber?`}
          render={() => {
            return (
              <OrgProvider>
                <CampaignsMainViewDataLoader>
                  <CampaignsMainView />
                </CampaignsMainViewDataLoader>
              </OrgProvider>
            );
          }}
        />
        <Route
          exact
          path={`${path}/details/:id?/:pageNumber?`}
          render={() => (
            <CampaignDetailsDataLoader>
              <CampaignDetailsChartsDataLoader>
                <CampaignsDetailsView />
              </CampaignDetailsChartsDataLoader>
            </CampaignDetailsDataLoader>
          )}
        />

        {/* TEMP: Usage page hidden. Restore this route (and 'Usage' in
            core/utils/constants/constants.js subRoutes.CAMPAIGNS) to re-enable.
        <Route
          exact
          path={`${path}/usage`}
          render={() => (
            <UsageLoader>
              <UsageView />
            </UsageLoader>
          )}
        />
        */}
        <Route exact path={`${path}/usage`} render={() => <Redirect to={`${path}/main`} />} />

        <Route
          exact
          path={`${path}/requester/edit/:id?`}
          render={() => (
            <CampaignRequestorProvider>
              <DealIdProvider>
                <LocationProvider>
                  <TagProvider>
                    <TargetingProvider>
                      <AudienceProvider>
                        <CreativeProvider>
                          <CampaignRequestorEdit />
                        </CreativeProvider>
                      </AudienceProvider>
                    </TargetingProvider>
                  </TagProvider>
                </LocationProvider>
              </DealIdProvider>
            </CampaignRequestorProvider>
          )}
        />
        <Route
          exact
          path={`${path}/requester/review/:id`}
          render={() => (
            <CampaignRequestorProvider>
              <DealIdProvider>
                <LocationProvider>
                  <TagProvider>
                    <TargetingProvider>
                      <AudienceProvider>
                        <CreativeProvider>
                          <CampaignRequestorReview />
                        </CreativeProvider>
                      </AudienceProvider>
                    </TargetingProvider>
                  </TagProvider>
                </LocationProvider>
              </DealIdProvider>
            </CampaignRequestorProvider>
          )}
        />
        <Route
          exact
          path={`${path}/boost/:id?`}
          render={() => (
            <CampaignLauncherLoader>
              <AmplifyView />
            </CampaignLauncherLoader>
          )}
        />

        <Route
          exact
          path={`${path}/v2/orderqueue/details/:id?`}
          render={() => (
            <CampaignRequestorProvider>
              <CampaignOrderQueueProvider>
                <DealIdProvider>
                  <CampaignOrderQueueReview />
                </DealIdProvider>
              </CampaignOrderQueueProvider>
            </CampaignRequestorProvider>
          )}
        />

        <Route
          exact
          path={`${path}/v2/orderqueue/:tab?`}
          render={() => (
            <CampaignOrderQueueProvider>
              <CampaignRequestorProvider>
                <CampaignOrderQueue />
              </CampaignRequestorProvider>
            </CampaignOrderQueueProvider>
          )}
        />

        <Route
          exact
          path={`${path}/audit/:id?`}
          render={() => (
            <CampaignOrderAuditLoader>
              <CampaignOrderAuditView />
            </CampaignOrderAuditLoader>
          )}
        />
        {/* Fallback */}
        <Route path={`${path}`} render={() => <Redirect to={`${path}/main/1`} />} />
      </Switch>
    </div>
  );
};

export default CampaignsRoutes;
